import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import updateDataLayer from '@/utils/gtml';
import clsx from 'clsx';
import FooterAccordion from './FooterAccordion';
const FooterLinkList = ({ title, links, collapsable, open }) => {
    const content = (_jsx("ul", { className: clsx('flex flex-col', collapsable ? 'gap-1' : 'gap-1.5 lg:gap-1'), children: links.map((link, index) => (_jsx("li", { children: _jsx("a", { href: link.url, target: link.target, "aria-label": link.ariaLabel, className: "text-s-body-regular hover:underline", onClick: () => {
                    updateDataLayer({
                        event: 'menuUsed',
                        menu_type: 'Footer',
                        main_category: title,
                        sub_category: link.text,
                    });
                }, children: link.text }) }, `${link.text}-${index}`))) }));
    return (_jsxs("div", { children: [collapsable ? (_jsx(FooterAccordion, { title: title, isOpen: open, children: content })) : (_jsxs("div", { className: "flex flex-col gap-1.5 lg:gap-1", children: [_jsx("p", { className: "type-feature-body", children: title }), content] })), _jsx("hr", { className: "my-1.5 border-border-muted lg:hidden" })] }));
};
export default FooterLinkList;
